import {fetch} from 'wix-fetch';
import {local,memory} from 'wix-storage';

$w.onReady(function () {
	// Write your code here

	$w("#headerTransitionPoint").onViewportLeave(() => {
		$w("#scrollingHeaderStrip").show();
		$w('#defaultHeaderStrip').hide();
	})
	

	$w("#headerTransitionPoint").onViewportEnter(() => {
		$w('#scrollingHeaderStrip').hide();
		$w('#defaultHeaderStrip').show();
	})

	
    fetch('https://extreme-ip-lookup.com/json', {
        method: 'get'
     })     // Check if the request was successful
     .then((httpResponse) => {
        if (httpResponse.ok) {
           return httpResponse.json();
        }
     })     
     .then((json) => {
        // Set the user's countryCode as a const
        const ipaddress = json.query;              
        local.setItem("ip", ipaddress);
     });

let value = local.getItem("ip"); // "value"
fetch('https://api.ipbase.com/v1/json?'+value+'?apikey=7c6cb0d0-9255-11ec-b95d-3b1353051079', {
        method: 'get', headers:  { "Access-Control-Allow-Origin": "https://www.firstclimate.com", "Content-Type": "application/json" }
     })     // Check if the request was successful
     .then((httpResponse) => {
        if (httpResponse.ok) {
           return httpResponse.json();
        }
     })     
     .then((json) => {
        // Set the user's countryCode as a const
        const countrycode = json.country_code;       
       //console.log("CC="+countrycode)

			if(countrycode == "CH") { // Change to your countrycode if want to test (DE, BE, ...) 
					$w("#FCMAGContact").collapse();
					$w("#FCCHAGContact").expand();
					$w("#text25").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate AG</p>";
					$w("#text268").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate Markets AG</p>";
					$w("#text269").html= "<p style='text-decoration:underline;font-weight:bold;'>First Climate Switzerland AG</p>";
					$w("#text223").text= "consulting@firstclimate.com";
					$w("#text223").link= "mailto:consulting@firstclimate.com";
					$w("#text224").text= "+ 41 44 298 28 00";
					$w("#text224").link= "tel:+ 41 44 298 28 00";
					$w("#section2part1p2").hide();
					$w("#text170").hide();
					$w("#button55").hide();
			}
        });
	
	
	
});

/**
*	Adds an event handler that runs when an input element's value
 is changed.
*	 @param {$w.Event} event
*/
import wixLocation from 'wix-location';

export function firstclimateselector_change(event) {
	let page = event.target.value; // new page name selected
	//console.log(page)
	if(page == "Item 1") {wixLocation.to("https://my.firstclimate.com/w/webpage/registration");} else {wixLocation.to("https://my.firstclimate.com/");}

}

// For full API documentation, including code examples, visit http://wix.to/94BuAAs
// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

import {session} from 'wix-storage';


let previousPageURL;

$w.onReady(function () {

	previousPageURL = session.getItem("page");
	//console.log(previousPageURL);
	session.setItem("page", wixLocation.url);
	$w("#button18").link = previousPageURL;
	$w("#button18").target = "_self";
});




/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text25_click(event) {
	$w("#FCContact").expand();	
	$w("#FCMAGContact").collapse();
	$w("#FCCHAGContact").collapse();
	$w("#text25").html= "<p style='text-decoration:underline;font-weight:bold;'>First Climate AG</p>";
	$w("#text268").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate Markets AG</p>";
	$w("#text269").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate Switzerland AG</p>";
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text268_click(event) {
	$w("#FCMAGContact").expand();
	//$w("#FCMAGContact").expand();
	$w("#FCCHAGContact").collapse();
	$w("#FCContact").collapse();		
	$w("#text25").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate AG</p>";
	$w("#text268").html= "<p style='text-decoration:underline;font-weight:bold;'>First Climate Markets AG</p>";
	$w("#text269").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate Switzerland AG</p>";
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text269_click(event) {
	//$w("#FCAGContact").collapse();
	$w("#FCMAGContact").collapse();
	$w("#FCCHAGContact").expand();
	$w("#FCContact").collapse();		
	$w("#text25").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate AG</p>";
	$w("#text268").html= "<p style='text-decoration:none;font-weight:bold;'>First Climate Markets AG</p>";
	$w("#text269").html= "<p style='text-decoration:underline;font-weight:bold;'>First Climate Switzerland AG</p>";
}

/**
*	Adds an event handler that runs when an input element's value
 is changed.
	[Read more](https://www.wix.com/corvid/reference/$w.ValueMixin.html#onChange)
*	 @param {$w.Event} event
*/
export function dropdown5_change(event) {
		let page = event.target.value; // new page name selected
	if(page == "Item 1") {wixLocation.to("https://my.firstclimate.com/w/webpage/registration");} else {wixLocation.to("https://my.firstclimate.com/");}
}

/**
*	Adds an event handler that runs when an input element's value
 is changed.
	[Read more](https://www.wix.com/corvid/reference/$w.ValueMixin.html#onChange)
*	 @param {$w.Event} event
*/
export function dropdown6_change(event) {
	let page = event.target.value; // new page name selected
	if(page == "Item 1") {wixLocation.to("https://my.firstclimate.com/w/webpage/registration");} else {wixLocation.to("https://my.firstclimate.com/");}
}